var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartShow)?_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-5 mx-auto"},[_c('RadarChart',{staticClass:"max-width-650",attrs:{"chart-data":_vm.chartGameData,"options":_vm.chartOptions}})],1),_c('div',{staticClass:"col-5 mx-auto"},[_c('ArrayTable',{attrs:{"dataTable":_vm.dataTableGames}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }